import { Table } from "antd";
import { withGetScreen } from "react-getscreen";

const formatNext = (record) => {
	if (record.is_bye) {
		return "Bye this week";
	}
	const next = record.next_game;
	if (!next) {
		return "";
	}
	const vs = next.home ? "vs" : "@";
	const bits = [`${vs} ${next.opponent_name || next.opponent_key}`];
	if (next.kickoff_label) {
		bits.push(next.kickoff_label);
	}
	return bits.join(" · ");
};

const divisionLabel = (record) => {
	const place = [record.conference, record.division]
		.filter((x) => x != null && String(x).trim() !== "")
		.join(" ");
	const rec = record.division_record;
	if (place && rec) {
		return `${place} ${rec}`;
	}
	return place || rec || "";
};

const TeamCell = ({ record }) => {
	const label = [record.city, record.name]
		.filter((x) => x != null && String(x).trim() !== "")
		.join(" ");
	const div = divisionLabel(record);
	const next = formatNext(record);
	const pick =
		record.pick == null || record.pick === "" ? "" : String(record.pick);
	const details = [];
	if (record.points_for != null || record.points_against != null) {
		details.push(
			`PF ${record.points_for ?? 0} · PA ${record.points_against ?? 0}`
		);
	}
	if (div) {
		details.push(`Division ${div}`);
	}
	if (pick) {
		details.push(`Overall pick ${pick}`);
	}
	if (next) {
		details.push(`Next ${next}`);
	}

	return (
		<div className="wl-nfl-team-cell">
			<img
				className="team_logo"
				src={record.logo}
				alt=""
				width={36}
				height={36}
			/>
			<div className="wl-nfl-team-cell__text">
				<div className="wl-nfl-team-cell__name">{label}</div>
				{details.length ? (
					<div className="wl-nfl-team-cell__meta">
						{details.map((line) => (
							<div key={line}>{line}</div>
						))}
					</div>
				) : null}
			</div>
		</div>
	);
};

const Guy_Table_NFL = (props) => {
	const columns = [
		{
			title: "Team",
			dataIndex: "team",
			key: "team",
			align: "left",
			render: (text, record) => <TeamCell record={record} />,
		},
		{
			title: props.isMobile() ? "W" : "Wins",
			dataIndex: "wins",
			key: "wins",
			align: "center",
		},
		{
			title: props.isMobile() ? "L" : "Losses",
			dataIndex: "losses",
			key: "losses",
			align: "center",
		},
		{
			title: props.isMobile() ? "T" : "Ties",
			dataIndex: "ties",
			key: "ties",
			align: "center",
		},
		{
			title: props.isMobile() ? "%" : "Winning Percentage",
			dataIndex: "percentage",
			key: "percentage",
			align: "center",
		},
	];

	const sortPick = (a, b) => {
		const pa = a.pick == null || a.pick === "" ? 9999 : Number(a.pick);
		const pb = b.pick == null || b.pick === "" ? 9999 : Number(b.pick);
		if (pa !== pb) {
			return pa - pb;
		}
		return String(a.key).localeCompare(String(b.key));
	};

	const rows =
		props.team_data && typeof props.team_data === "object"
			? Object.entries(props.team_data)
			: [];

	const data = rows
		.map((item) => {
			const row = item[1] || {};
			return {
				key: row.key,
				city: row.city,
				name: row.name,
				logo: row.logo,
				wins: row.wins,
				losses: row.losses,
				ties: row.ties,
				percentage: row.percentage,
				pick: row.pick,
				points_for: row.points_for,
				points_against: row.points_against,
				division_record: row.division_record,
				conference: row.conference,
				division: row.division,
				next_game: row.next_game,
				is_bye: row.is_bye,
			};
		})
		.sort(sortPick);

	return (
		<Table
			columns={columns}
			dataSource={data}
			pagination={false}
			rowKey={(row) => `${row.pick}-${row.key}`}
		/>
	);
};

export default withGetScreen(Guy_Table_NFL);
